/**
 * Project : workspace
 * File    : AppNavigator.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package navigation

import androidx.compose.ui.unit.dp
import androidx.navigation.NavHostController
import appConfig.AppConfig
import com.parmartechnologies.business.feature.business.viewModel.BusinessViewModel
import com.parmartechnologies.commerce.feature.alert.handler.AlertHandler
import com.parmartechnologies.commerce.feature.jsonDecoder
import com.parmartechnologies.commerce.feature.payment.viewModel.PaymentViewModel
import com.parmartechnologies.core.feature.payment.model.Payment
import com.parmartechnologies.core.navigation.BaseNavigator
import com.parmartechnologies.core.navigation.NavigationParam
import com.parmartechnologies.core.navigation.model.NavParam
import com.parmartechnologies.core.navigation.model.NavParamStore
import com.parmartechnologies.storage.store.UserDefaults
import graph.AppType
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import navigation.base.FriendlyWindow.Companion.navigationController
import presentation.screens.customer.store.StoreDetailScreen
import theme.ThemeColor

/**
 * Represents the app navigator class.
 */

class AppNavigator{
    val scope = CoroutineScope(Job() + Dispatchers.Default)
    val mainScope = CoroutineScope(Job() + Dispatchers.Main)
    var onWindowLocationChange: ((String) -> Unit)? = null
    var openRazorpay: ((Payment) -> Unit)? = null
    private var openLink: ((String) -> Unit)? = null
    var authController : NavHostController? = null
    var paramTempStore : MutableList<NavParam> = mutableListOf()
    /**
 * Executes the go back operation.
 *
 * @receiver TODO
 * @return Unit – no return value.
 */
    fun goBack(){
        mainScope.launch {
            navigationController?.popBackStack()
        }
    }
    /**
 * Executes the go back auth operation.
 *
 * @receiver TODO
 * @return Unit – no return value.
 */
    fun goBackAuth(){
        mainScope.launch {
            authController?.popBackStack()
        }
    }
    /**
 * Executes the set param operation.
 *
 * @receiver TODO
 * @param name The name.
 * @param value The value.
 * @return Unit – no return value.
 */
    fun setParam(name: String,value: NavigationParam){
        val allParams: MutableList<NavParam>  = getAllParams()
        val allNewParam : MutableList<NavParam> = mutableListOf()
        var existing = false
        val newParam = NavParam(route = name,value)
        allParams.forEach {param->
            if(param.route == name){
                allNewParam.add(newParam)
                existing = true
            }else{
                allNewParam.add(param)
            }
        }
        if(!existing){
            allNewParam.add(newParam)
        }
        if(allNewParam.isEmpty()){
            allNewParam.add(newParam)
        }
        val paramStore = NavParamStore(params = allNewParam)
        val storeStr = jsonDecoder.encodeToString(paramStore)
        UserDefaults.shared().store("nav_param",storeStr)

        var index = 0
        existing = false
        paramTempStore.forEach {
            if(it.route == name){
                paramTempStore[index] = newParam
                existing = true
            }
            index+=1
        }
        if(!existing){
            paramTempStore.add(newParam)
        }

    }
    /**
 * Executes the get param operation.
 *
 * @receiver TODO
 * @param name The name.
 * @return The resulting navigation param.
 */
    fun getParam(name: String):NavigationParam{
        val allParams = getAllParams()
        var param : NavigationParam? = null
        allParams.forEach {par->
            if(par.route == name){
                param = par.param
            }
        }
        if(param == null){
            paramTempStore.forEach {para->
                if(para.route == name){
                    param = para.param
                }
            }
        }
        return param ?: NavigationParam()
    }
    /**
 * Executes the get all params operation.
 *
 * @receiver TODO
 * @return The resulting mutable list< nav param>.
 */
    fun getAllParams(): MutableList<NavParam>{
        val str = UserDefaults.shared().retrieve("nav_param")
        val store = NavParamStore(listOf())
        if(str.isNotEmpty()){
            val paramStore : NavParamStore = jsonDecoder.decodeFromString(str)
            store.params = paramStore.params
        }else if(paramTempStore.isNotEmpty()){
            store.params = paramTempStore
        }
        return store.params.toMutableList()
    }

    /**
 * Executes the navigate operation.
 *
 * @receiver TODO
 * @param url The url.
 * @return Unit – no return value.
 */

    fun navigate(url: String){
        mainScope.launch {
            navigationController?.navigate(url)
        }
    }
    /**
 * Executes the navigate operation.
 *
 * @receiver TODO
 * @param url The url.
 * @param param The param.
 * @return Unit – no return value.
 */
    fun navigate(url: String,param: NavigationParam?){
        setParam(url,param ?: NavigationParam())
        mainScope.launch {
            navigationController?.navigate(url)
        }
    }
    /**
 * Executes the get navigation param operation.
 *
 * @receiver TODO
 * @return The resulting navigation param.
 */
    fun getNavigationParam(): NavigationParam{
        val route = navigationController?.currentDestination?.route
        val params = getParam(route ?: "")
        return params
    }
    private val currentUrl: String
        get() {
            return ""
//            return UserDefaults.shared().retrieve(KeyConstant.deeplink)
        }
    private val currentScreenName: String
        get() {
            return ""
//            return UserDefaults.shared().retrieve("current_screen")
        }

    private var redirectNavigations = arrayListOf("privacy_policy", "delete_account")
    var screenWidth = 400.dp
    var screenHeight = 600.dp
    val navigationParam: String
        get() {
            return ""
//            return UserDefaults.shared().retrieve("navigation_param")
        }
    init {
        instance = this
    }

    companion object {
        private var instance: AppNavigator? = null
        /**
 * Executes the shared operation.
 *
 * @receiver TODO
 * @return The resulting app navigator.
 */
        fun shared(): AppNavigator {
            return if (instance != null) {
                instance as AppNavigator
            } else {
                instance = AppNavigator()
                BaseNavigator.shared().onBackPress = {
                    instance?.goBack()
                }
                instance as AppNavigator
            }
        }
    }

    /**
 * Executes the check deployed domain for web operation.
 *
 * @receiver TODO
 * @param url The url.
 * @return Unit – no return value.
 */

    fun checkDeployedDomainForWeb(url: String) {
        if (url.isNotEmpty() && url.contains("business.mandee.ai")) {
            AppConfig.shared().appType = AppType.BUSINESS
            ThemeColor.shared().PrimaryColor = ThemeColor.shared().businessTheme
        } else if (url.isNotEmpty() && url.contains("mandee.ai")) {
            AppConfig.shared().appType = AppType.CUSTOMER
            ThemeColor.shared().PrimaryColor = ThemeColor.shared().customerTheme
        } else if (url.isNotEmpty() && url.contains("localhost")) {
            AppConfig.shared().appType = AppType.BUSINESS
            ThemeColor.shared().PrimaryColor = ThemeColor.shared().businessTheme
        } else {
            AppConfig.shared().appType = AppType.E_COMMERCE
            ThemeColor.shared().PrimaryColor = ThemeColor.shared().customerTheme
        }
    }

    private fun openInvoice(id: String) {
        CoroutineScope(Job() + Dispatchers.Main).launch {
            delay(300)
//            currentScreen?.navigateTo(ScreenName.INVOICES, NavigationParam(id))
        }
    }

    private fun openStore(number: Long) {
        scope.launch {
            BusinessViewModel().getBusinessByNumber(number) { bus ->
                val screen = StoreDetailScreen()
//                screen.navigationParam = AppNavigator.shared().getNavigationParam()(business = bus!!, selectedBusiness = bus)
            }
        }
    }

    private fun openStore(id: String) {
        scope.launch {
            BusinessViewModel().getBusinessById(id) { bus ->
                val screen = StoreDetailScreen()
//                screen.navigationParam = AppNavigator.shared().getNavigationParam()(business = bus!!, selectedBusiness = bus)
            }
        }
    }

    /**
 * Executes the open payment page operation.
 *
 * @receiver TODO
 * @param id The id.
 * @return Unit – no return value.
 */

    fun openPaymentPage(id: String) {
        if (id.isEmpty()) {
            scope.launch {
                delay(200)
                AlertHandler.shared().showAlert("Oops!", "Payment details are missing")
            }
        } else {
            val viewModel = PaymentViewModel()
            viewModel.find(id) { payment: Payment? ->
                if (payment != null) {
                    openRazorpay!!(payment)
                }
            }
        }
    }

    /**
 * Executes the handle link operation.
 *
 * @receiver TODO
 * @param url The url.
 * @return Unit – no return value.
 */

    fun handleLink(url: String) {
        val splitLink = url.split("/")
        var lastComponent = splitLink.last()
        var value = ""
        if (lastComponent.contains("?")) {
            val params = lastComponent.split("?")
            lastComponent = params.first()
            if (params.last().contains("=")) {
                val keyvals = params.last().split("=")
                if (keyvals.first().isNotEmpty()) {
//                    UserDefaults.shared().store("navigation_param", keyvals.first())
//                    UserDefaults.shared().store("navigation_param_value", keyvals.last())
                }
                if (keyvals.last().isNotBlank()) {
                    value = keyvals.last()
                }
            }
        }
        scope.launch {
            delay(200)
            if (lastComponent.contains("invoices") && value.isNotEmpty()) {
                openInvoice(value)
            }
            if ((lastComponent.contains("stores")) && value.isNotEmpty()) {
                try {
                    openStore(value.toLong())
                } catch (e: Exception) {
                    openStore(value)
                }
            }
            if (lastComponent == "privacy_policy") {
//                shared().navigateTo(ScreenName.PRIVACY_POLICY)
            }
            if (lastComponent == "delete_account") {
//                shared().navigateTo(ScreenName.DELETE_ACCOUNT)
            }
            if (lastComponent == "payment_pay") {
                openPaymentPage(id = value)
            }
        }
    }

    /**
 * Executes the pop operation.
 *
 * @receiver TODO
 * @return Unit – no return value.
 */

    fun pop() {
        if (onWindowLocationChange != null && !currentUrl.contains("localhost") && redirectNavigations.contains(
                currentScreenName
            )
        ) {
            onWindowLocationChange!!("")
        } else {
            AppNavigator.shared().goBack()
        }
    }

    /**
 * Executes the pop all operation.
 *
 * @receiver TODO
 * @return Unit – no return value.
 */

    fun popAll() {
        if (onWindowLocationChange != null && !currentUrl.contains("localhost") && redirectNavigations.contains(
                currentScreenName
            )
        ) {
            onWindowLocationChange!!("")
        } else {
        }
    }

    /**
 * Executes the open link operation.
 *
 * @receiver TODO
 * @param link The link.
 * @return Unit – no return value.
 */

    fun openLink(link: String) {
        if (openLink != null) {
            scope.launch {
                openLink(link)
            }
        }
    }

    /**
 * Executes the navigate to operation.
 *
 * @receiver TODO
 * @param page The page.
 * @param param The param.
 * @param Any> TODO
 * @return Unit – no return value.
 */

    fun navigateTo(page:String,param:Pair<String,Any>){
        when(page){
            "stores"->{
                try {
                    openStore(param.second.toString().toLong())
                } catch (e: Exception) {
                    openStore(param.second.toString())
                }
            }
        }
    }

}